import { Flex, Text } from '@chakra-ui/react';
import { X } from 'lucide-react';
import * as React from 'react';

import { Button } from '../button';
import {
  filterBarChipGap,
  filterBarOuterGap,
  filterBarPaddingY,
  filterBarSectionGap,
} from './table-toolbar.kds';

export interface FilterBarProps {
  /** Called when "Clear all" is clicked. If omitted, the clear button is hidden. */
  onClearAll?: () => void;
  /** Filter chip elements. */
  children?: React.ReactNode;
}

export const FilterBar = React.forwardRef<HTMLDivElement, FilterBarProps>(function FilterBar(props, ref) {
  const { onClearAll, children } = props;

  return (
    <Flex
      ref={ref}
      align="center"
      gap={filterBarOuterGap}
      py={filterBarPaddingY}
      borderTopWidth="1px"
      borderTopStyle="solid"
      borderTopColor="neutral.100"
      bg="neutral.0"
      data-testid="filter-bar"
    >
      <Flex align="center" gap={filterBarSectionGap}>
        <Text textStyle="default.regular" color="neutral.250" whiteSpace="nowrap" flexShrink={0}>
          Filtered by
        </Text>
        <Flex align="center" gap={filterBarChipGap} flexWrap="wrap">
          {children}
        </Flex>
      </Flex>

      {onClearAll && (
        <Button
          variant="ghost"
          colorPalette="neutral"
          leftIcon={X}
          onClick={onClearAll}
          flexShrink={0}
          data-testid="filter-bar-clear"
        >
          Clear all
        </Button>
      )}
    </Flex>
  );
});
FilterBar.displayName = 'FilterBar';
